// module.exports = {}
/* */
export default {
    button: {
        add: "Add",
        clone: "Clone",
        delete: "Delete",
        deleteFeedback: "Delete feedback",
        open: "Open",
        save: "Save",
        view: "View",
        prev: "Prev",
        previous: "Previous",
        next: "Next",
        yes: "Yes",
        no: "No"
    },
    customer: {
        editor: {
            confirmDelete: "Are you sure you want to delete this customer?",
            typeCustomerName: "Type customer name to confirm removal",
            name: "Customer Editor",
            email: "Customer email",
        },
        showDisabled: "Show disabled customers",
    },
    clipboard: {
        copied: "Copied!"
    },
    login: {
        in: "Log in",
        out: "Log out",
    },
    main: {
        admin: "Admin",
        auth0uid: "Auth0 uid",
        contact: "Contact",
        customer: "Customer",
        customers: "Customers",
        dashboardEditor: "Dashboard editor",
        dashboards: "Dashboards",
        email: "Email",
        name: "Name",
        targets: "Targets",
        users: "Users",
        welcome: "Welcome to {{application}}",
        password: "Password",
    },
    user: {
        showDisabled: "Show disabled users",
        editor: {
            name: "User Editor",
            auth0uid: "Auth0 uid",
            confirmDelete: "Are you sure you want to delete user: ",
            disabled: "Disabled",
        },
    },
    timestamps: {
        createdAt: "Created",
        updatedAt: "Updated",
        timeAt: "at",
    },
    target: {
        showDisabled: "Show disabled targets",
        editor: {
            name: "Target Editor",
            available: "Available Targets in Admin",
            button: {
                add: "Add new target",
                addLocalisation: "Add localization",
                addQuestionLocalisation: "Add Question localization",
                addThankYouLocalisation: "Add Thank you localization",
                admin: "Admin",
                clone: "Clone",
                contact: "Contant",
                custom: "Custom",
                default: "Default",
                disabled: "Disabled",
                enable: "Enable",
                enabled: "Enabled",
                feel: "Feel",
                generate: "Generate QR code with texts",
                generateWithoutTexts: "Generate QR code without texts",
                marketing: "Marketing",
                next: "Next",
                nps: "NPS",
                open: "Open",
                picture: "Or click here to select a picture",
                plus: "Plus",
                previous: "Prev",
                qrCodeGenerator: "QR-code genarator",
                reversed: "Reversed",
                save: "Save",
                special: "Special",
                super: "Super",
                view: "View",

            },
            label: {
                additionalQuestions: "Additional questions",
                baseTarget: "Use this as a base target for a chain",
                button1: "Button 1",
                button2: "Button 2",
                button3: "Button 3",
                button4: "Button 4",
                button5: "Button 5",
                button6: "Button 6",
                button7: "Button 7",
                button8: "Button 8",
                category: "Category",
                customer: "Customer",
                description: "Description",
                enable: "Enable",
                endPage: "End page",
                feedbackQuestionNegative: "Feedback question if Negative (-)",
                feedbackQuestionNeutral: "Feedback question if Neutral",
                feedbackQuestionPositive: "Feedback question if Positive (+)",
                getback: "Get back to this after last target",
                iconsOrder: "Icons order",
                iconsPath: "Icons path",
                imageButton: "Image button",
                languageMenu: "Language menu",
                legalNotice: "Legal notice",
                legalNoticeURL: "Legal Notice URL",
                linked: "Linked",
                locationEnabled: "Location enabled",
                lotteryRules: "Lottery rules",
                lotteryRulesURL: "Lottery rules URL",
                maxValue: "Max value",
                measurementType: "Measure",
                minValue: "Min value",
                noVoting: "No voting",
                optionalFields: "Optional fields",
                optionalQuestions: "Optional questions",
                otherSettings: "Other settings",
                parent: "Parent",
                picture: "Picture",
                question: "Question",
                showNPSfooter: "Show NPS footer",
                skipButton: "Skip button",
                subtitle: "Subtitle",
                tags: "Tags",
                thanksText: "Thanks text",
                thankYouPage: "Thank you page",
                theme: "Theme",
                title: "Title",
                topicButtons: "Topic buttons",
                topicButtonsSubtitle: "Subtitle",
                topicButtonsTitle: "Title",
                votingLimit: "Voting limit",
                votingLimitKey: "Voting limit key",
                votingLimitTime: "Voting limit time in seconds",
                votingScale: "Voting scale",
                whistleblower: "Whistleblower",
                dropZeroNPS: "Drop zero NPS with empty feedback",
                dropNegativeNPS: "Drop negative NPS with empty feedback",
                noAutosubmitWhenEmpty: "Disable autosubmit with empty feedback",
            },
            confirmDelete: "Are you sure you want to delete target: ",
            confirmDeleteFeedback: "Are you sure you want to delete feedback given to target: ",
            contact: {
                contactMe: "Contact me",
                contactFormTitle: "Contact form title",
                showName: "Show name",
                showCompany: "Show company",
                showEmail: "Show email",
                showPhone: "Show phone",
                showRoom: "Show room number",
                showTeam: "Show team",
                showAddress: "Show address",
                showZIP: "Show zip-code",
                showCity: "Show city",
                showCountry: "Show country",
                showAge: "Show age",
                showGenre: "Show genre",
                title: "Contact",
            },
            custom: {
                custom1: "Custom 1",
                custom2: "Custom 2",
                custom3: "Custom 3",
                custom4: "Custom 4",
                custom5: "Custom 5",
                custom6: "Custom 6",
                title: "Custom",
            },
            marketing: {
                noSMS: "No marketing SMS",
                noEmail: "No marketing email",
                noCall: "No marketing calls",
                noText: "No marketing messages",
                title: "Marketing",
            },
            special: {
                linkingTarget: "Linking target",
                styleSettings: "Style settings",
                title: "Special",
            },
            qrCode: {
                scale: "QR-code scale",
                title: "QR-code Title",
                URL: "QR-code URL",
                warning: "Always test QR-Code before use",
            },
            question: {
                add: "Add",
            },
        },
    },
    dashboard: {
        name: "Dashboard editor",
        showDisabled: "Show disabled dashboards",
        editor: {
            available: "Available dashboards",
            authenticated: "Authenticated",
            availableDashboards: "Available dashboards in Admin",
            availableTargets: "Available targets",
            buttonVisibility: "Feedback button visibility",
            // users: "Users",
            chart: {
                showFeelings: "Feelings chart",
                showCustomerFeelings: "Customer Feelings chart",
                showEmployeeFeelings: "Employee Feelings chart",
                showHistory: "History chart",
                showNPS: "NPS chart",
                showENPS: "eNPS chart",
                showNPSDis: "NPS distribution",
                showPie: "Pie chart",
                showPlus: "Plus chart",
                showOverviewIcon: "Overview icon"
            },
            chartVisibility: "Chart visibility",
            commentsbcc: "Comments Bcc",
            confirmDelete: "Are you sure you want to delete this dashboard: ",
            disabled: "Dashboard disabled",
            enableAnalytics: "Order a report",
            feedback: {
                show: {
                    disabled: "Show disabled",
                    empty: "Show empty feedback",
                    feedback: "Show feedback",
                    image: "Show image",
                    show: "Show feedback",
                    time: {
                        range: "Time range",
                    },
                },
            },
            feedbackVisibility: "Feedback visibility",
            name: "Dashboard name",
            ratingButtons: {
                showStatus: "\"Status\"",
                showCommentsBtn: "\"Show comments\"",
                showStarBtn: "\"Starred\"",
                showHideBtn: "\"Hide\"",
                showCloseBtn: "\"Remove\"",
                showPublishBtn: "\"Publish\"",
                showLikeBtn: "\"Like\"",
            },
            showImage: "Show image",
            showDisabled: "Show disabled targets",
            notificationLink: "Link to notifications",
            comments: {
              email: "Email comments",
            },
            layout: {
                public: "Public layout",
            },
            theme: "Theme",
            type: "Type",
            security: {
                autheticated: "Authenticated",
            },
            time: {
                dateFormat: "yyyy/MM/dd hh:mm aa",
                from: "From",
                label: "Time",
                range: "Time range",
                timeFormat: "hh:mm aa",
                to: "To",
            },
            users: "Users",
        },
    },
};
/**/
